import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./AdminSendSso.css";
import Layout from "../../components/layout";

const AdminSendSso = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/send-sso-email`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        toast.success(data.message || "SSO email sent successfully!");

        // Delay the navigation by 3 seconds to allow the toast to be visible
        setTimeout(() => {
          navigate("/sso-login");
        }, 3000);
      } else {
        const errorData = await response.json();
        toast.error(errorData.message || "Error sending SSO email");
      }
    } catch (error) {
      toast.error("Error sending SSO email");
      console.error("Error:", error);
    }
  };

  return (
    <Layout>
      <div className="Bottom">
        <div className="admin-container">
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={true}
            newestOnTop={true}
            closeOnClick
            pauseOnHover
            limit={1} // Limits to one toast visible at a time
            style={{ width: "250px", fontSize: "14px" }} // Adjusts width and font size for a smaller appearance
          />
          <h2 className="admin-heading">Nutzer einladen mit SSO</h2>
          <form className="admin-form" onSubmit={handleSubmit}>
            <label className="admin-label">
              Nutzer Email:
              <input
                className="admin-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value.toLowerCase())}
                required
                placeholder="Email-Adresse eingeben"
              />
            </label>
            <button className="admin-btn" type="submit">
              Sende SSO Email
            </button>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default AdminSendSso;
